// extracted by css-extract-rspack-plugin
var _1 = "MenuBadge-m_badgeNew-LyZ_Wx5a MenuBadge-m_dot-Qqfg8YtE";
var _2 = "MenuBadge-m_dot-Qqfg8YtE";
var _3 = "MenuBadge-m_upgrade-DbRGRS1h MenuBadge-m_dot-Qqfg8YtE";
export { _1 as "badgeNew", _2 as "dot", _3 as "upgrade" }
